import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function UniqueMechanism() {
  return <Section className="bg-brand-beige" data-id="element-613">
      <div className="max-w-5xl mx-auto" data-id="element-614">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-615">
          {/* For You */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border-t-4 border-emerald-500" data-id="element-616">
            <h3 className="text-xl font-bold text-gray-900 mb-6 uppercase tracking-wide" data-id="element-617">
              Mamá Digital 2.0 es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-618">
              {['Eres mamá joven y quieres un ingreso extra desde casa', 'Solo tienes tu celular y ratitos libres', 'Quieres algo simple (sin cursos eternos)', 'Te gustaría vender por IG/WhatsApp a tu ritmo', 'Quieres empezar con un producto fácil: un PDF'].map((item, i) => <li key={i} className="flex items-start text-gray-700" data-id="element-619">
                  <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-620" />
                  <span data-id="element-621">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border-t-4 border-rose-500" data-id="element-622">
            <h3 className="text-xl font-bold text-gray-900 mb-6 uppercase tracking-wide" data-id="element-623">
              NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-624">
              {['Buscas hacerte rica "sin hacer nada"', 'No estás dispuesta a dedicar 1–2 horas al día por una semana', 'Quieres un negocio con inventario, envíos o complicaciones'].map((item, i) => <li key={i} className="flex items-start text-gray-700" data-id="element-625">
                  <X className="w-5 h-5 text-rose-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-626" />
                  <span data-id="element-627">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}